import { request } from '../utils/Api';

export function fetchAppData(fields) { // eslint-disable-line
  return dispatch => (
    new Promise((resolve, reject) => {
      request('config').then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_APP_DATA',
            payload: response.data,
          });

          resolve();
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function getBlogPosts() {
  return dispatch => (
    new Promise((resolve, reject) => {
      request('blog').then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_BLOG_POSTS',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function getBlogPost(slug) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request(`blog/${slug}`).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_BLOG_POST_BY_ID',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function getFAQs() {
  return dispatch => (
    new Promise((resolve, reject) => {
      request('faq').then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_FAQS',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function getResources() {
  return dispatch => (
    new Promise((resolve, reject) => {
      request('resources').then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_RESOURCES',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function getTestimonials() {
  return dispatch => (
    new Promise((resolve, reject) => {
      request('testimonials').then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_TESTIMONIALS',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function getTerms() {
  return dispatch => (
    new Promise((resolve, reject) => {
      request('terms').then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_TERMS',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function getPrivacy() {
  return dispatch => (
    new Promise((resolve, reject) => {
      request('privacy').then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_PRIVACY',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}



// WEBPACK FOOTER //
// ./src/actions/applicationData.js